import React from 'react'
import Dialog from '../../../common/Dialog'
import './UserExistsDialog.css'
import $t from '../../../../i18n'
import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import actions from '../../../../actions'
import config from '../../../../config.json'

const UserExistsDialog = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(state => state.payment.emailExistsModalPPF)
  const onCloseDialog = () => {
    window.open('https://www.antidotehealth.ai', '_self')
    dispatch(actions.createAction(actions.CLOSE_EMAIL_EXIST_MODAL))
  }

  const renderDialogFooter = () => (
    <Button
      type="primary"
      onClick={() => window.open(config.whatsappURL, `_self`)}
    >
      {$t('pages.paymentplan.contact')}
    </Button>
  )

  return (
    <>
      {' '}
      <Dialog
        title={$t('pages.paymentplan.emailExistDesc')}
        isVisible={isOpen}
        footerActions={renderDialogFooter()}
        className={'unsupported-dialog overwrite-email-existing-dialog'}
        onCancel={onCloseDialog}
      >
        <></>
      </Dialog>
    </>
  )
}

export default UserExistsDialog
